import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { trackTrace } from '@fora-monorepo/webapp-analytics';

export const trackTraceMarkupStartDateValidation = (markupStartDateInputValue: string, errorMessages: string[]) =>
  trackTrace(
    `Markup startdate invalid, validation failed despite datepicker boundaries. Value: ${markupStartDateInputValue}, Error: ${errorMessages} `,
    SeverityLevel.Information
  );
